export enum ResetPasswordPath {
  token = "token",
}

export interface PathParams {
  [ResetPasswordPath.token]: string;
}
